import pkg from '../package.json'
import { contains, filter, find, prop, uniq } from 'ramda'
import fetch from 'unfetch'
import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

import { AgeGateError, GameLockedError } from './util/error'

Vue.use(Vuex)

const LOCAL_STORAGE_KEY = 'cracker-jack'
const vuexPersist = new VuexPersistence({
  key: LOCAL_STORAGE_KEY,
  storage: localStorage,
  reducer: state => ({ ...state, games: void 0 }),
})

export default new Vuex.Store({
  plugins: [ vuexPersist.plugin ],

  state: {
    isAtLeast13: null,
    games: [],
    unlockedGames: [ 'connect' ],
    codesInput: [],
    knmCode: false,
  },

  mutations: {
    setIsAtLeast13 (state, status) {
      state.isAtLeast13 = status
    },

    setGames (state, games) {
      state.games = games
    },

    addUnlockedGame (state, id) {
      state.unlockedGames = uniq([ ...state.unlockedGames, id ])
    },

    addCodeInput (state, id) {
      state.codesInput = uniq([ ...state.codesInput, id ])
    },

    setKnmCode (state) {
      state.knmCode = true
    },
  },

  getters: {
    games: state => state.games,
    unlockedGames: state => state.unlockedGames,
    gameWithId: state => id => find(x => x.id === id, state.games),
    isGameUnlocked: state => id => contains(id, state.unlockedGames),
    stickerGames: state => filter(prop('needsSticker'), state.games || [ ]),
    knmCode: state => state.knmCode,
    version: state => pkg.version,
    isDevEnv: state => window.localStorage.debug || contains(
      window.location.hostname,
      [
        'dev.blvz.im',
        'cracker-jack.test',
        'crackerjack-staging.shoshkey.com',
      ]
    ),
  },

  actions: {
    checkAge ({ state }) {
      if (!state.isAtLeast13) {
        throw new AgeGateError()
      }
    },

    async checkGameUnlocked ({ getters, dispatch }, id) {
      await dispatch('loadGames')
      if (!getters.isGameUnlocked(id)) {
        throw new GameLockedError()
      }
    },

    async loadGames ({ getters, commit }) {
      try {
        const res = await fetch('data/games.json')
        const games = await res.json()
        commit('setGames', games)

        
        return games
      } catch (err) { }
    },

    async unlockGame ({ getters, commit, dispatch }, id) {
      await dispatch('loadGames')
      const game = getters.gameWithId(id)

      if (game) {
        if (!getters.isGameUnlocked(id)) {
          commit('addUnlockedGame', id)
          dispatch('analytics', [ 'Unlock', 'Game', id ])
        }
      } else {
        throw new GameLockedError()
      }
    },

    async unlockAll ({ getters, commit, dispatch }) {
      commit('setIsAtLeast13', true)
      commit('setKnmCode')

      await dispatch('loadGames')
      const games = getters.games

      for (let idx = 0; idx < games.length; idx++) {
        const game = games[idx]
        await dispatch('unlockGame', game.id)
      }
    },

    inputCode ({ commit, dispatch }, id) {
      commit('addCodeInput', id)
      dispatch('analytics', [ 'Solved', 'Riddle', id ])
    },

    resetAll ({ getters }) {
      window.localStorage.removeItem(LOCAL_STORAGE_KEY)
      window.location.reload()
    },

    analytics (store, [ action, category, label ]) {
      if (!window.gtag) return

      window.gtag('event', action, {
        'event_category': category,
        'event_label': label,
      })
    },
  },
})
